const get = require('lodash/get')
const { getUnknownBatchID } = require('../../shipment/tools/virtual-batch')

const generateShipmentItems = (counts) => {
  return Object.keys(counts).reduce((acc, product) => {
    const value = {
      sku: product,
      quantity: get(counts[product], 'quantity', 0),
      returnReason: 'Damaged', // TODO: Part of default reasons in shipsy
      batchId: getUnknownBatchID(`product:${product}`), // TODO: Default till we have SL batch management
      expiryDate: '3050-12-31' // TODO: Default till we have SL batch management
    }

    acc.push(value)
    return acc
  }, [])
}

const generateReturnShipment = (shipment, locationById) => {
  const items = generateShipmentItems(shipment.counts)
  const d = new Date(shipment.createdAt)
  const shipmentDate = d.toISOString().split('T')[0]
  const shipmentNumber = shipment.shipmentNumber
  const data = {
    origin: get(locationById[shipment.originId], 'uuid'),
    destination: get(locationById[shipment.destinationId], 'code'),
    shipmentDate,
    orderId: shipmentNumber,
    shipmentType: 'return',
    items,
    shipmentNo: shipmentNumber
  }

  return data
}

module.exports = generateReturnShipment
